<template>
    <div>
        <input type="file" ref="fileInput" @change="handleFileUpload" accept="image/*" style="display: none" />
    </div>
</template>

<script>
export default {

    mounted () {
        console.log('ImageMenu')
        this.$refs.fileInput.click();
    },

    methods: {
        handleFileUpload(event) {
            const file = event.target.files[0];
            this.$emit('addSticker','image', {
                data: {
                    file,
                }
            })
        }
    }
}
</script>
